var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{ref:"myApp",attrs:{"hide-top":"","hid-side":"","hide-notifications":"","loading":true,"force-reset-frame":_vm.resetFrame}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }